import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useFreePlay } from '../../context/FreePlayContext';
import { useAuth } from '../../context/AuthContext';

import './GameDashboard.css';

// Simple text-link navigation between the account pages (tanks-style plain
// styled words). Rendered at the bottom of the Account Dash, Leaderboard and
// Buy Spins popups; the current page's own link is hidden. `current` hides a
// link by label for popups without a route; `onNavigate` runs before any
// link fires (e.g. closing the popup the nav sits in).
const DashNav = ({ current, onNavigate }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { openPayment } = useFreePlay();
  const { isAuthenticated, openAuth } = useAuth();

  const links = [
    { label: 'Account Dash', to: '/dashboard' },
    { label: 'Leaderboard', to: '/leaderboard' },
    { label: 'Instructions', to: '/instructions' },
    {
      label: 'Buy Spins',
      action: () => {
        if (!isAuthenticated) {
          openAuth('purchase');
        } else {
          openPayment('dashboard');
        }
      }
    }
  ];

  // Inside a popup (`current` set) only the popup's own link is hidden —
  // the underlying page's link stays, since clicking it closes the popup
  // to reveal that page. On a page, the page's own link is hidden.
  const visible = links.filter((link) =>
    current ? link.label !== current : link.to !== pathname
  );

  return (
    <div className="game-dashboard__nav">
      {visible.map((link, i) => (
        <React.Fragment key={link.label}>
          <button
            type="button"
            className="game-dashboard__nav-link"
            onClick={() => {
              if (onNavigate) onNavigate();
              if (link.to) navigate(link.to);
              else link.action();
            }}
          >
            {link.label}
          </button>
          {i < visible.length - 1 && (
            <span className="game-dashboard__nav-dot">/</span>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default DashNav;
